import React from "react";
import { Divider, Group, Paper } from "@mantine/core";
import { MerchantInstitutionModal } from "../ManageMerchant/modals/MerchantModals";
import { LogoUploadModal } from "./components/modals/AddLogoModal";
import CustomButton from "../ui/CustomButton/CustomButton";
import {
  CompanyLogoSection,
  CompanyInfoSection,
  ContactPhoneSection,
} from "./components/CompanyDetailsSections";
import useMerchantEditHandler from "./components/hooks/useMerchantEditHandler";
import useLogoUploadHandler from "./components/hooks/useLogoUploadHandler";


const CompanyDetailsContent = ({ merchantProfile }) => {
  const merchantEditHandler = useMerchantEditHandler();
  const logoUploadHandler = useLogoUploadHandler();

  return (
    <>
      <Paper shadow="xs" radius="md" p={{ base: "sm", sm: "xl" }} className="bg-white">
        <Group justify="space-between" align="center" mb="sm" wrap="wrap" gap="sm">
          <div>
            <h1 className="text-base sm:text-xl font-semibold text-gray-900">
              Account Information
            </h1>
            <p className="text-xs sm:text-sm text-gray-600 mt-1">
              Company details overview
            </p>
          </div>

          <CustomButton
            variant="primary"
            className="text-blue"
            radius="xl"
            onClick={() =>
              merchantEditHandler.handleEditMerchant(merchantProfile)
            }
          >
            Edit Account Info
          </CustomButton>
        </Group>

        <Divider my="lg" />

        <CompanyLogoSection
          logoBase64={merchantProfile?.logoBase64}
          onUploadClick={logoUploadHandler.handleOpenLogoModal}
        />

        <Divider my="lg" />

        <div className="space-y-8">
         
          <CompanyInfoSection merchantProfile={merchantProfile} />

          <Divider my="lg" />

         
          <ContactPhoneSection
            contactPhoneNumbers={merchantProfile?.contactPhoneNumbers}
          />
        </div>
      </Paper>

      
      <MerchantInstitutionModal
        opened={merchantEditHandler.modalOpen}
        onClose={merchantEditHandler.handleCloseModal}
        mode={merchantEditHandler.modalMode}
        fieldsToShow={[
          "merchantName",
          "nationality",
          "address",
          "country",
          "city",
          "county",
        ]}
        control={merchantEditHandler.merchantForm.control}
        modeRef={merchantEditHandler.merchantForm.modeRef}
        isSubmitting={merchantEditHandler.isSubmitting}
        disableSubmit={merchantEditHandler.disableSubmit}
        onSubmit={merchantEditHandler.handleSubmit}
      />

      <LogoUploadModal
        opened={logoUploadHandler.logoModalOpen}
        onClose={logoUploadHandler.handleCloseLogoModal}
        mode={merchantProfile?.logoBase64 ? "edit" : "create"}
        onSubmit={logoUploadHandler.handleLogoSubmit}
        isSubmitting={logoUploadHandler.isSubmitting}
        initialLogo={
          merchantProfile?.logoBase64 ? `${merchantProfile.logoBase64}` : null
        }
      />
    </>
  );
};

export default CompanyDetailsContent;
